import React from 'react';
import MobileLogo from './mobile-view-logo.png'

const RetailLogoPage = () => {
    return (
        <img src={MobileLogo} alt='logo' height="150px" width="157px" style={{ marginTop: '-55px' }}  />
    )
}

export default RetailLogoPage;